// @ts-strict-ignore
import type { LazyQueryHookOptions, QueryHookOptions } from "@apollo/client";
import { useQuery, gql, useLazyQuery } from "@apollo/client";

const ProductById_Emerson_Query = gql`
  query ProductById_Emerson_Query($productId: ID!) {
    viewer {
      product: node(id: $productId) {
        ... on Product {
          id
          slug
          brand {
            id
            name
          }
          availableOrMasterVariant {
            id
            emersonVariantId
          }
        }
      }
    }
  }
`;

interface ProductData {
  viewer: {
    product: {
      id: string;
      slug: string;
      brand: {
        id: string;
        name: string;
      };
      availableOrMasterVariant: {
        id: string;
        emersonVariantId: string;
      };
    };
  };
}

interface ProductVariables {
  productId?: string;
}

const useProductByIdQuery = (options?: QueryHookOptions<ProductData, ProductVariables>) => {
  return useQuery<ProductData, ProductVariables>(ProductById_Emerson_Query, {
    variables: { ...options.variables },
  });
};

const useProductByIdLazyQuery = (options?: LazyQueryHookOptions<ProductData, ProductVariables>) => {
  return useLazyQuery<ProductData, ProductVariables>(ProductById_Emerson_Query, {
    ...options,
  });
};

export type { ProductVariables, ProductData };

// eslint-disable-next-line @fullscript/gql-no-manual-hook-declaration
export { useProductByIdQuery, useProductByIdLazyQuery, ProductById_Emerson_Query };
